import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const CorpusLink = (context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.corpus',
    link: '/corpus/' + context.globalCorpusId,
    icon: 'navigation-link__corpus',
});